import React__default from "react";
const ListboxContext = React__default.createContext(null);
const useListboxContext = () => {
  const context = React__default.useContext(ListboxContext);
  if (context === null) {
    throw new Error("Listbox components must be wrapped in <Listbox />");
  }
  return context;
};
const ListboxProvider = ({ children, value }) => {
  return /* @__PURE__ */ React__default.createElement(ListboxContext.Provider, { value }, children);
};
export {
  ListboxContext,
  ListboxProvider,
  useListboxContext
};
